// ======================= DealsInSeller.jsx =======================
import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { Form, Button, Row, Col, Table, Spinner, Modal } from "react-bootstrap";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import AppContext from "../../../context/AppContext";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { Wallet as WalletIcon } from "lucide-react"; // ✅ NEW
import Swal from "sweetalert2"; // ✅ NEW
import "../../../assets/css/seller/DealsInSeller/dealsInSeller.css";


// =====================================================
// PAKISTAN TIME HELPERS
// =====================================================
const pakistanTimeToUTC = (dateTimeLocal) => {
  if (!dateTimeLocal) return "";
  const date = new Date(`${dateTimeLocal}:00+05:00`);
  if (isNaN(date.getTime())) return "";
  return date.toISOString();
};

const utcToPakistanInput = (dateTime) => {
  if (!dateTime) return "";
  const date = new Date(dateTime);
  if (isNaN(date.getTime())) return "";
  const pakistanDate = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Karachi",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const parts = {};
  pakistanDate.forEach(({ type, value }) => { parts[type] = value; });
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

const formatPakistanDateTime = (dateTime) => {
  if (!dateTime) return "—";
  const date = new Date(dateTime);
  if (isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-PK", {
    timeZone: "Asia/Karachi",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const getPakistanDateTimeLocal = () => {
  const now = new Date();
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Karachi",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(now);
  const data = {};
  parts.forEach(({ type, value }) => { data[type] = value; });
  return `${data.year}-${data.month}-${data.day}T${data.hour}:${data.minute}`;
};

// ✅ NEW — format amount with commas
const formatAmount = (value) => Number(value || 0).toLocaleString("en-PK");

const DealsInSeller = () => {
  const { baseUrl, baseUrlForFiles, regTpChecker } = useContext(AppContext);
  const [btnLabel, setBtnLabel] = useState("Save");
  const [idToUpdateDeleteDeal, setIdToUpdateDeleteDeal] = useState("");
  const [deal_type, setDeal_type] = useState("");
  const [category, setCategory] = useState(null);
  const [deal_title, setDeal_title] = useState("");
  const [description, setDescription] = useState("");
  const [deal_location, setDeal_Location] = useState("");
  const [services, setServices] = useState([]);
  const [serviceInput, setServiceInput] = useState("");
  const [services_price, setServices_price] = useState("");
  const [isServiceEdit, setIsServiceEdit] = useState(false);
  const [idToUpdateService, setIdToUpdateService] = useState();
  const [discount_percentage, setDiscount_percentage] = useState("");
  const [deal_price, setDeal_price] = useState(0);
  const [deal_actualprice, setDeal_actualprice] = useState(0);
  const [deal_image, setDeal_image] = useState(null);
  const [deals, setDeals] = useState([]);
  const [categories, setCategories] = useState([]);
  const [addUploadLoading, setAddUploadLoading] = useState(false);
  const [aiGenerating, setAiGenerating] = useState(false);
  const [start_at, setStart_at] = useState("");
  const [expires_at, setExpires_at] = useState("");
  const [errors, setErrors] = useState({});
  const [showViewModal, setShowViewModal] = useState(false);
  const [dealToView, setDealToView] = useState(null);

  // ✅ NEW — seller wallet balance
  const [sellerBalance, setSellerBalance] = useState(0);
  const [balanceLoading, setBalanceLoading] = useState(false);

  // datetime-local value ko local Pakistan time ke taur par preserve karta hai
  const formatDealDateTime = (dateTime) => {
    if (!dateTime) return "";

    // API se agar ISO UTC date aa rahi ho
    const date = new Date(dateTime);

    if (isNaN(date.getTime())) return "";

    const pad = (num) => String(num).padStart(2, "0");
  };
  const getAllCategories = () => {
    axios
      .post(`${baseUrl}/shop/tpcategory/viewAllUploadedCategories`)
      .then((res) => setCategories(res.data.categoryRecords))
      .catch((err) => console.error(err));
  };

  const viewAllUploadedDeals = () => {
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    if (!loggedInSeller) {
      console.log("Seller not logged in");
      return;
    }
    axios
      .post(`${baseUrl}/shop/Tpdeal/viewAllUploadedDeals`, {
        tpshop_id: loggedInSeller.id,
      })
      .then((response) => setDeals(response.data.deals))
      .catch((error) => console.log(error));
  };

  // ---------------- FETCH SELLER BALANCE ---------------- ✅ NEW
  const fetchSellerBalance = () => {
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));

    if (!loggedInSeller?.id) return;

    setBalanceLoading(true);

    axios
      .post(`${baseUrl}/seller/wallet/viewSellerBalance`, {
        tpshop_id: loggedInSeller.id,
      })
      .then((response) => {
        if (response.data.success) {
          setSellerBalance(Number(response.data.balance) || 0);
        }
      })
      .catch((error) => {
        console.log("Balance Error:", error.response?.data || error);
      })
      .finally(() => setBalanceLoading(false));
  };

  // ---------------- CALCULATE DEAL PRICE ----------------
  // ✅ FIX: ab actual_price (services ka total, discount se pehle) bhi set hoti hai
  const calculateDealPrice = (
    servicesArr = services,
    discount = discount_percentage,
  ) => {
    const total = servicesArr.reduce(
      (sum, s) => sum + Number(s.itemprice || 0),
      0,
    );
    setDeal_actualprice(total.toFixed(2));
    const discounted = total - (total * (Number(discount) || 0)) / 100;
    setDeal_price(discounted.toFixed(2));
  };

  const resetServiceFields = () => {
    setServiceInput("");
    setServices_price("");
    setIsServiceEdit(false);
    setIdToUpdateService(null);
  };

  const validateServiceInput = () => {
    const newErrors = {};
    if (!serviceInput || serviceInput.trim().length < 2) {
      newErrors.serviceInput = "Service name must be at least 2 characters";
    }
    if (
      !services_price ||
      isNaN(services_price) ||
      Number(services_price) <= 0
    ) {
      newErrors.services_price = "Enter a valid service price";
    }
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const addService = () => {
    if (!validateServiceInput()) return;
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const formData = new FormData();
    formData.append("itemname", serviceInput);
    formData.append("itemprice", services_price);
    formData.append("tpshop_id", loggedInSeller.id);

    axios
      .post(`${baseUrl}/shop/tpdealitem/addDealItem`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        viewAllDealItems();
        resetServiceFields();
        setErrors((prev) => ({
          ...prev,
          serviceInput: "",
          services_price: "",
          services: "",
        }));
      })
      .catch((error) => console.log(error));
  };

  const updateSingleDealItem = () => {
    if (!validateServiceInput()) return;
    const formdata = new FormData();
    formdata.append("id", idToUpdateService);
    formdata.append("itemname", serviceInput);
    formdata.append("itemprice", services_price);

    axios
      .post(`${baseUrl}/shop/tpdealitems/updateSingleDealItem`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        console.log(res.data);
        setIsServiceEdit(false);
        setServiceInput("");
        setServices_price("");
        viewAllDealItems();
      })
      .catch((err) => console.error(err));
  };

  const viewAllDealItems = () => {
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    if (!loggedInSeller) return;
    axios
      .post(`${baseUrl}/shop/tpdealitem/viewAllDealItems`, {
        tpshop_id: loggedInSeller.id,
      })
      .then((response) => setServices(response.data.dealitems));
  };

  const validateDealForm = () => {
    const newErrors = {};
    if (!deal_type) newErrors.deal_type = "Please select deal type";
    if (!category) newErrors.category = "Please select category";

    const titleErr = regTpChecker("dealTitle", deal_title);
    if (titleErr) newErrors.deal_title = titleErr;

    if (!deal_location || deal_location.trim().length < 2) {
      newErrors.deal_location = "Please enter deal location";
    }

    if (!services || services.length === 0) {
      newErrors.services = "Please add at least one service";
    }

    const discountErr = regTpChecker("discountPercentage", discount_percentage);
    if (discountErr) newErrors.discount_percentage = discountErr;

    if (deal_type === "Instant Deals") {
      if (!start_at) newErrors.start_at = "Please select deal start date & time";
      if (!expires_at) newErrors.expires_at = "Please select deal expiry date & time";

      if (start_at && expires_at) {
        const startDate = new Date(start_at);
        const expiryDate = new Date(expires_at);

        if (isNaN(startDate.getTime())) {
          newErrors.start_at = "Please enter a valid start date & time";
        }
        if (isNaN(expiryDate.getTime())) {
          newErrors.expires_at = "Please enter a valid expiry date & time";
        }
        if (
          !isNaN(startDate.getTime()) &&
          !isNaN(expiryDate.getTime()) &&
          expiryDate <= startDate
        ) {
          newErrors.expires_at = "Expiry date & time must be after start date & time";
        }
      }
    }

    if (btnLabel === "Save" && !deal_image) {
      newErrors.deal_image = "Please select a deal image";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const uploadDeal = () => {
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const formdata = new FormData();
    formdata.append("deal_type", deal_type);
    formdata.append("tpcategory_id", category);
    formdata.append("deal_title", deal_title);
    formdata.append("description", description);
    formdata.append("deal_location", deal_location);
    formdata.append("services", JSON.stringify(services));
    formdata.append("discount_percentage", discount_percentage);
    formdata.append("actual_price", deal_actualprice);
    formdata.append("deal_price", deal_price);
    formdata.append("tpshop_id", loggedInSeller.id);
    if (start_at) formdata.append("start_at", pakistanTimeToUTC(start_at));
    if (expires_at) formdata.append("expires_at", pakistanTimeToUTC(expires_at));
    if (deal_image) formdata.append("deal_image", deal_image);

    axios
      .post(`${baseUrl}/shop/Tpdeal/uploaddeal`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        // ==========================================
        // ✅ NEW — BACKEND BALANCE CHECK RESPONSE
        // Agar balance available nahi tha, backend
        // success:false + insufficient_balance bhejega
        // ==========================================
        if (response.data.success) {
          viewAllUploadedDeals();
          resetForm();

          Swal.fire({
            icon: "success",
            title: "Deal Created",
            text: "Your deal has been created successfully.",
          });
        } else if (response.data.insufficient_balance) {
          Swal.fire({
            icon: "warning",
            title: "Insufficient Balance",
            html: `Aapke wallet ka balance available nahi hai (<b>PKR ${formatAmount(
              response.data.balance,
            )}</b>).<br/>Naya deal create karne se pehle apna commission wallet top up karein.`,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: response.data.message || "Unable to create deal.",
          });
        }

        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log("ERROR:", err.response);
        console.log("DATA:", err.response?.data);
        console.log(err);

        Swal.fire({
          icon: "error",
          title: "Failed",
          text: err.response?.data?.message || "Unable to create deal.",
        });

        setAddUploadLoading(false);
      });
  };

  const updateDeal = () => {
    const formdata = new FormData();
    formdata.append("id", idToUpdateDeleteDeal);
    formdata.append("deal_type", deal_type);
    formdata.append("tpcategory_id", category);
    formdata.append("deal_title", deal_title);
    formdata.append("description", description);
    formdata.append("deal_location", deal_location);
    formdata.append("services", JSON.stringify(services));
    formdata.append("discount_percentage", discount_percentage);
    formdata.append("actual_price", deal_actualprice);
    formdata.append("deal_price", deal_price);
    if (start_at) formdata.append("start_at", start_at);
    if (expires_at) formdata.append("expires_at", expires_at);
    if (deal_image) formdata.append("deal_image", deal_image);

    axios
      .post(`${baseUrl}/shop/Tpdeal/updateDeal`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        viewAllUploadedDeals();
        resetForm();
        setAddUploadLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setAddUploadLoading(false);
      });
  };

  const deleteDeal = (idToDelete) => {
    const formdata = new FormData();
    formdata.append("id", idToDelete);
    axios
      .post(`${baseUrl}/shop/Tpdeal/deleteDeal`, formdata)
      .then(() => viewAllUploadedDeals());
  };

  const generateDescriptionWithAI = () => {
    if (!deal_title.trim()) {
      setErrors((prev) => ({
        ...prev,
        deal_title: "Pehle deal title likho, phir AI se description generate karo.",
      }));
      return;
    }

    setAiGenerating(true);
    const categoryName = categories.find((c) => c.id == category)?.categoryName || "";

    axios
      .post(`${baseUrl}/shop/Tpdeal/generateDescription`, {
        title: deal_title,
        category: categoryName,
        deal_type: deal_type,
      })
      .then((response) => {
        if (response.data.success) {
          setDescription(response.data.description);
          setErrors((prev) => ({ ...prev, description: "" }));
        }
        setAiGenerating(false);
      })
      .catch((err) => {
        console.log(err);
        setAiGenerating(false);
      });
  };

  const resetForm = () => {
    setDeal_type("");
    setCategory();
    setDeal_title("");
    setDescription("");
    setDeal_Location("");
    setServices([]);
    setServiceInput("");
    setServices_price("");
    setDiscount_percentage("");
    setDeal_price(0);
    setDeal_actualprice(0);
    setDeal_image(null);
    setIdToUpdateDeleteDeal("");
    setBtnLabel("Save");
    setIsServiceEdit(false);
    setIdToUpdateService(null);
    setStart_at("");
    setExpires_at("");
    setErrors({});
  };

  const openViewModal = (deal) => {
    setDealToView(deal);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setDealToView(null);
  };

  useEffect(() => {
    getAllCategories();
    viewAllUploadedDeals();
    viewAllDealItems();
    fetchSellerBalance(); // ✅ NEW
  }, []);

  useEffect(() => {
    calculateDealPrice();
  }, [services, discount_percentage]);

  // ✅ NEW — balance not available (negative) flag, used to visually warn/disable
  const isBalanceAvailable = sellerBalance >= 0;

  return (
    <SellerMasterLayout>
      {/* ================= ✅ NEW — WALLET BALANCE CARD ================= */}
      <div
        className="form-card mb-3"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: isBalanceAvailable ? "#e9f7ef" : "#fdecea",
              color: isBalanceAvailable ? "#16a34a" : "#dc3545",
            }}
          >
            <WalletIcon size={20} />
          </div>

          <div>
            <div style={{ fontSize: "12px", color: "#777" }}>
              Wallet Balance
            </div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: 700,
                color: isBalanceAvailable ? "#16a34a" : "#dc3545",
              }}
            >
              {balanceLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>PKR {formatAmount(sellerBalance)}</>
              )}
            </div>
          </div>
        </div>

        {!isBalanceAvailable && !balanceLoading && (
          <div
            style={{
              fontSize: "13px",
              color: "#dc3545",
              background: "#fdecea",
              padding: "8px 12px",
              borderRadius: "8px",
            }}
          >
            Balance available nahi hai. Naya deal create karne se pehle wallet
            top up karein.
          </div>
        )}
      </div>

      <div className="form-card">
        <h4>{btnLabel === "Save" ? "Create New Deal" : "Update Deal"}</h4>

        <Form noValidate>
          {/* Deal Type & Category */}
          <Row>
            <Col lg={6}>
              <Form.Label>Deal Type</Form.Label>
              <Form.Select
                value={deal_type}
                isInvalid={!!errors.deal_type}
                onChange={(e) => {
                  const selectedType = e.target.value;
                  setDeal_type(selectedType);
                  setErrors((prev) => ({
                    ...prev,
                    deal_type: "",
                    start_at: "",
                    expires_at: "",
                  }));
                  if (selectedType !== "Instant Deals") {
                    setStart_at("");
                    setExpires_at("");
                  }
                }}
                required
              >
                <option value="">Select Deal Type</option>
                <option value="Instant Deals">Instant Deals</option>
                <option value="Hot Deals">Hot Deals</option>
                <option value="Trending Deals">Trending Deals</option>
              </Form.Select>
              <Form.Control.Feedback
                type="invalid"
                style={{ display: errors.deal_type ? "block" : "none" }}
              >
                {errors.deal_type}
              </Form.Control.Feedback>
            </Col>

            <Col lg={6}>
              <Form.Label>Category</Form.Label>
              <Form.Select
                value={category}
                isInvalid={!!errors.category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setErrors((prev) => ({ ...prev, category: "" }));
                }}
                required
              >
                <option value="">Select Category</option>
                {categories.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.categoryName}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback
                type="invalid"
                style={{ display: errors.category ? "block" : "none" }}
              >
                {errors.category}
              </Form.Control.Feedback>
            </Col>
          </Row>

          {/* Title & Description */}
          <Row className="mt-3">
            <Col lg={6}>
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                value={deal_title}
                isInvalid={!!errors.deal_title}
                onChange={(e) => {
                  setDeal_title(e.target.value);
                  setErrors((prev) => ({ ...prev, deal_title: "" }));
                }}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.deal_title}
              </Form.Control.Feedback>
            </Col>
            <Col lg={6}>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-1">
                <Form.Label className="mb-0">Description</Form.Label>
                {/* <Button
                  size="sm"
                  variant="outline-success"
                  disabled={aiGenerating}
                  onClick={generateDescriptionWithAI}
                >
                  {aiGenerating ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-1" />
                      Generating...
                    </>
                  ) : (
                    "✨ Generate with AI"
                  )}
                </Button> */}
              </div>
              <Form.Control
                as="textarea"
                rows={2}
                value={description}
                isInvalid={!!errors.description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  setErrors((prev) => ({ ...prev, description: "" }));
                }}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Col>
          </Row>

          {/* Location */}
          <Row className="mt-3">
            <Col lg={6}>
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                placeholder="e.g. Gulberg, Lahore"
                value={deal_location}
                isInvalid={!!errors.deal_location}
                onChange={(e) => {
                  setDeal_Location(e.target.value);
                  setErrors((prev) => ({ ...prev, deal_location: "" }));
                }}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.deal_location}
              </Form.Control.Feedback>
            </Col>
          </Row>

          {/* CHANGE: Service, Service Price, Discount %, aur Add/Update
              Service button — ab sab ek hi line (Row) mein hain.
              Column widths: 4+3+3+2 = 12 */}
          <Row className="mt-3 align-items-end">
            <Col lg={4}>
              <Form.Label>Service</Form.Label>
              <Form.Control
                type="text"
                value={serviceInput}
                isInvalid={!!errors.serviceInput}
                onChange={(e) => {
                  setServiceInput(e.target.value);
                  setErrors((prev) => ({ ...prev, serviceInput: "" }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.serviceInput}
              </Form.Control.Feedback>
            </Col>
            <Col lg={3}>
              <Form.Label>Service Price</Form.Label>
              <Form.Control
                type="number"
                value={services_price}
                isInvalid={!!errors.services_price}
                onChange={(e) => {
                  setServices_price(e.target.value);
                  setErrors((prev) => ({ ...prev, services_price: "" }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.services_price}
              </Form.Control.Feedback>
            </Col>

            {/* Discount % — yahan move ki gayi hai (pehle neeche alag Row mein thi) */}
            <Col lg={3}>
              <Form.Label>Discount %</Form.Label>
              <Form.Control
                type="number"
                value={discount_percentage}
                isInvalid={!!errors.discount_percentage}
                onChange={(e) => {
                  setDiscount_percentage(e.target.value);
                  setErrors((prev) => ({ ...prev, discount_percentage: "" }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.discount_percentage}
              </Form.Control.Feedback>
            </Col>

            <Col lg={2}>
              {isServiceEdit ? (
                <Button type="button" onClick={() => updateSingleDealItem()}>
                  Update Service
                </Button>
              ) : (
                <Button type="button" onClick={addService}>
                  Add Service
                </Button>
              )}
            </Col>
          </Row>

          <Row>
            <Col lg={12} className="mt-2">
              {services.map((s) => (
                <span
                  key={s.id}
                  style={{
                    background: "#e9f7ef",
                    padding: "6px 10px",
                    borderRadius: "20px",
                    marginRight: "8px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "5px",
                  }}
                >
                  {/* Service name - click karke edit */}
                  <span
                    onClick={() => {
                      setIsServiceEdit(true);
                      setIdToUpdateService(s.id);
                      setServiceInput(s.itemname);
                      setServices_price(s.itemprice);

                      setErrors((prev) => ({
                        ...prev,
                        serviceInput: "",
                        services_price: "",
                      }));
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {s.itemname} (Rs. {s.itemprice})
                  </span>

                  {/* Remove button */}
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();

                      setServices((prevServices) =>
                        prevServices.filter((service) => service.id !== s.id),
                      );

                      // Agar remove ki hui service edit mode mein thi
                      if (idToUpdateService === s.id) {
                        resetServiceFields();
                      }

                      // Agar koi service remove ho to services error clear
                      setErrors((prev) => ({
                        ...prev,
                        services: "",
                      }));
                    }}
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "#dc3545",
                      fontWeight: "bold",
                      cursor: "pointer",
                      padding: "0",
                      lineHeight: "1",
                      fontSize: "16px",
                    }}
                    title="Remove service"
                  >
                    ×
                  </button>
                </span>
              ))}
              {errors.services && (
                <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                  {errors.services}
                </div>
              )}
            </Col>
          </Row>

          {/* CHANGE: Discount % yahan se hata di gayi (upar move ho chuki),
              ab sirf Actual Price aur Deal Price — dono ki width lg=6 kar
              di taake barabar jagah lein */}
          <Row className="mt-3">
            <Col lg={6}>
              <Form.Label>Actual Price</Form.Label>
              <Form.Control type="number" value={deal_actualprice} readOnly />
              <Form.Text className="text-muted">
                Services ka total (discount se pehle) — auto calculate hota hai.
              </Form.Text>
            </Col>

            <Col lg={6}>
              <Form.Label>Deal Price</Form.Label>
              <Form.Control type="number" value={deal_price} readOnly />
              <Form.Text className="text-muted">
                Discount ke baad final price — auto calculate hota hai.
              </Form.Text>
            </Col>
          </Row>

          {deal_type === "Instant Deals" && (
            <Row className="mt-3">
              <Col lg={6}>
                <Form.Label>Deal Start Date & Time</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={start_at}
                  isInvalid={!!errors.start_at}
                  min={getPakistanDateTimeLocal()}
                  onChange={(e) => {
                    setStart_at(e.target.value);
                    setErrors((prev) => ({
                      ...prev,
                      start_at: "",
                      expires_at: "",
                    }));
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.start_at}
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                  Deal is date & time par active hona start hogi.
                </Form.Text>
              </Col>

              <Col lg={6}>
                <Form.Label>Deal Expiry Date & Time</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={expires_at}
                  isInvalid={!!errors.expires_at}
                  min={start_at || new Date().toISOString().slice(0, 16)}
                  onChange={(e) => {
                    setExpires_at(e.target.value);
                    setErrors((prev) => ({ ...prev, expires_at: "" }));
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.expires_at}
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                  Is date & time ke baad deal automatically expire ho jayegi.
                </Form.Text>
              </Col>
            </Row>
          )}

          <Row className="mt-3">
            <Col>
              <Form.Label>Deal Image</Form.Label>
              <Form.Control
                type="file"
                isInvalid={!!errors.deal_image}
                onChange={(e) => {
                  setDeal_image(e.target.files[0]);
                  setErrors((prev) => ({ ...prev, deal_image: "" }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.deal_image}
              </Form.Control.Feedback>
            </Col>
          </Row>

          <div className="mt-4">
            {addUploadLoading ? (
              <Spinner size="lg" />
            ) : (
              <Button
                type="button"
                disabled={addUploadLoading}
                onClick={() => {
                  if (addUploadLoading) return;

                  // ==========================================
                  // ✅ NEW — FRONTEND QUICK CHECK
                  // (Backend is the real authority, ye sirf
                  // seller ko turant feedback dene ke liye hai)
                  // ==========================================
                  if (btnLabel === "Save" && !isBalanceAvailable) {
                    Swal.fire({
                      icon: "warning",
                      title: "Insufficient Balance",
                      html: `Aapke wallet ka balance available nahi hai (<b>PKR ${formatAmount(
                        sellerBalance,
                      )}</b>).<br/>Naya deal create karne se pehle apna commission wallet top up karein.`,
                    });
                    return;
                  }

                  if (!validateDealForm()) return;
                  setAddUploadLoading(true);
                  if (btnLabel === "Save") uploadDeal();
                  else updateDeal();
                }}
              >
                {btnLabel === "Save" ? "Create Deal" : "Update Deal"}
              </Button>
            )}
          </div>
        </Form>
      </div>

      {/* ================= TABLE ================= */}
      <div className="form-card mt-4">
        <h4>All Deals</h4>
        <Table bordered responsive>
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Type</th>
              <th>Category</th>
              <th>Price</th>
              <th>Discount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {deals.length > 0 ? (
              deals.map((deal) => (
                <tr key={deal.id}>
                  <td>
                    <img
                      onClick={() => {
                        window.location.href = `${baseUrlForFiles}/${deal.deal_image}`;
                      }}
                      src={`${baseUrlForFiles}/${deal.deal_image}`}
                      alt="deal"
                      width="60"
                      style={{ borderRadius: "8px", cursor: "pointer" }}
                    />
                  </td>
                  <td>{deal.deal_title}</td>
                  <td>{deal.deal_type}</td>
                  <td>{deal.tpcategory?.categoryName}</td>
                  <td>Rs. {deal.deal_price}</td>
                  <td>{deal.discount_percentage}%</td>
                  <td>
                    <span
                      className={`badge ${
                        deal.status === "Active"
                          ? "bg-success"
                          : deal.status === "Sold"
                            ? "bg-secondary"
                            : "bg-danger"
                      }`}
                    >
                      {deal.status}
                    </span>
                  </td>
                  <td>
                    <div className="actions-group">
                      <button
                        className="btn-action btn-view"
                        onClick={() => openViewModal(deal)}
                      >
                        <FaEye />
                      </button>
                      {deal.status !== "Sold" && (
                        <>
                          <button
                            className="btn-action btn-edit"
                            onClick={() => {
                              setIdToUpdateDeleteDeal(deal.id);
                              setDeal_type(deal.deal_type);
                              setCategory(deal.tpcategory_id);
                              setDeal_title(deal.deal_title);
                              setDescription(deal.description);
                              setDeal_Location(deal.deal_location);
                              try {
                                setServices(
                                  typeof deal.services === "string"
                                    ? JSON.parse(deal.services)
                                    : deal.services || [],
                                );
                              } catch (error) {
                                setServices([]);
                              }
                              setDiscount_percentage(deal.discount_percentage);
                              setDeal_actualprice(deal.actual_price);
                              setDeal_price(deal.deal_price);
                              setDeal_image(deal.deal_image);
                              setStart_at(utcToPakistanInput(deal.start_at));
                              setExpires_at(utcToPakistanInput(deal.expires_at));
                              setBtnLabel("Update");
                              setErrors({});
                            }}
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn-action btn-delete"
                            onClick={() => deleteDeal(deal.id)}
                          >
                            <FaTrash />
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center">
                  No deals found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* ================= VIEW MODAL ================= */}
      <Modal show={showViewModal} onHide={closeViewModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{dealToView?.deal_title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dealToView && (
            <>
              <Row className="mb-3">
                <Col md={4}>
                  <img
                    src={`${baseUrlForFiles}/${dealToView.deal_image}`}
                    alt="deal"
                    width="100%"
                    style={{ borderRadius: "8px" }}
                  />
                </Col>
                <Col md={8}>
                  <p><strong>Type:</strong> {dealToView.deal_type}</p>
                  <p><strong>Category:</strong> {dealToView.tpcategory?.categoryName}</p>
                  <p><strong>Location:</strong> {dealToView.deal_location}</p>
                  <p><strong>Status:</strong> {dealToView.status}</p>
                  <p>
                    <strong>Starts At:</strong>{" "}
                    {dealToView.start_at ? formatPakistanDateTime(dealToView.start_at) : "—"}
                  </p>
                  <p>
                    <strong>Expires At:</strong>{" "}
                    {dealToView.expires_at ? formatPakistanDateTime(dealToView.expires_at) : "—"}
                  </p>
                </Col>
              </Row>

              <p><strong>Description:</strong></p>
              <p>{dealToView.description}</p>

              <p><strong>Services:</strong></p>
              {dealToView.tpdealitems?.length > 0 ? (
                dealToView.tpdealitems.map((s) => (
                  <div key={s.id}>{s.itemname} - Rs. {s.itemprice}</div>
                ))
              ) : (
                <div>No services added.</div>
              )}

              <hr />
              <p><strong>Discount:</strong> {dealToView.discount_percentage}%</p>
              <p><strong>Actual Price:</strong> Rs. {dealToView.actual_price}</p>
              <p><strong>Deal Price:</strong> Rs. {dealToView.deal_price}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeViewModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </SellerMasterLayout>
  );
};

export default DealsInSeller;